import Autocomplete from "components/Forms/Autocomplete.js";
import TSSelect from "components/Forms/TSSelect.js";
import TSText from "components/Forms/TSText.js";
import QRCode from 'qrcode.react';
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, Col, Container, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap";
import { handleResponse } from '_helpers';
import "../assets/css/customCheckbox.css";
import '../assets/css/react-datetime.css';




const VaccinePfizerQueue2 = (props) => {
    const cid = (props.match.params.cid !== undefined) ? props.match.params.cid : null;

    const [Cid, setCid] = useState("");
    const [confirmCid, setconfirmCid] = useState("");
    const [titleOption, setTitleOption] = useState([]);
    const [schoolOption, setSchoolOption] = useState([]);

    const [Visit, setVisit] = useState([]);
    const [EventList, setEventList] = useState([]);

    const [qSkin, setqSkin] = useState([]);
    const [qTrang, setqTrang] = useState([]);
    const [qWP, setqWP] = useState([]);
    const [qTRPH, setqTRPH] = useState([]);
    const [qTest, setqTest] = useState([]);

    const [FullName, setFullName] = useState("");
    const [CertId, setCertId] = useState("");
    const [HospCode, setHospCode] = useState("");
    const [BirthDT, setBirthDT] = useState('');

    const [bDay, setbDay] = useState("");
    const [bMonth, setbMonth] = useState("");
    const [bYear, setbYear] = useState("");

    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [TitleName, setTitleName] = useState("");
    const [TitleKey, setTitleKey] = useState("");
    const [SchoolKey, setSchoolKey] = useState("");

    const [Weight, setWeight] = useState("");
    const [Height, setHeight] = useState("");
    const [Temp1, setTemp1] = useState("");
    const [Temp2, setTemp2] = useState("");


    const [RowNumber, setRowNumber] = useState("");
    const [AppointDT1, setAppointDT1] = useState("");
    const [AppointDT2, setAppointDT2] = useState("");

    const [QueueNumber, setQueueNumber] = useState("");
    const [QueueNumber2, setQueueNumber2] = useState("");
    const [QueueNumber3, setQueueNumber3] = useState("");
    const [QueueNumber4, setQueueNumber4] = useState("");
    const [QueueNumber5, setQueueNumber5] = useState("");
    const [QueueNumber6, setQueueNumber6] = useState("");

    const [QueueDate, setQueueDate] = useState("");
    const [QueueDate2, setQueueDate2] = useState("");
    const [QueueDate3, setQueueDate3] = useState("");
    const [QueueDate4, setQueueDate4] = useState("");
    const [QueueDate5, setQueueDate5] = useState("");
    const [QueueDate6, setQueueDate6] = useState("");

    const [QueueTime, setQueueTime] = useState("");
    const [QueueTime2, setQueueTime2] = useState("");
    const [QueueTime3, setQueueTime3] = useState("");
    const [QueueTime4, setQueueTime4] = useState("");
    const [QueueTime5, setQueueTime5] = useState("");
    const [QueueTime6, setQueueTime6] = useState("");


    const [VaccineType, setVaccineType] = useState("");
    const [VaccinePlace, setVaccinePlace] = useState("");
    const [VaccineTypeNew, setVaccineTypeNew] = useState("");
    const [QueueDT, setQueueDT] = useState("");

    const [VaccineEventKey, setVaccineEventKey] = useState("");



    const [SchoolName, setSchoolName] = useState("");
    const [ClassYear, setClassYear] = useState("");
    const [ClassYearName, setClassYearName] = useState("");
    const [ClassRoom, setClassRoom] = useState("");

    const [subDistrictOption, setSubDistrictOption] = useState([]);

    const [Phone, setPhone] = useState("");
    const [address, setAddress] = useState('');
    const [province, setProvince] = useState('');
    const [amphur, setAmphur] = useState('');
    const [district, setDistrict] = useState('');
    const [SlotID, setSlotID] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [IsSearch, setIsSearch] = useState(false);
    const [inj1Hosp, setinj1Hosp] = useState("");
    const [inj2Hosp, setinj2Hosp] = useState("");
    const [IsHideButton, setIsHideButton] = useState(false);
    const [TargetType, setTargetType] = useState(0);
    const [ErrorMsg2, setErrorMsg2] = useState('');


    const [IsOrangePfizer, setIsOrangePfizer] = useState(false);

    const [IsKnow, setIsKnow] = useState(false);

    
    const [i_address, invalidAddress] = useState(false);
    const [i_district, invalidDistrict] = useState(false);
    const [i_amphur, invalidAmphur] = useState(false);
    const [i_province, invalidProvince] = useState(false);
    const [i_phone, invalidPhone] = useState(false);

    const [errMsg, setErrMsg] = React.useState(false);
    const [modalError, setModalError] = React.useState(false);
    const [modalConfirm, setModalConfirm] = React.useState(false);
    const [modalConfirm2, setModalConfirm2] = React.useState(false);


    const [IsNew, setIsNew] = useState(false);

    const [icon, setIcon] = useState("far fa-question-circle");


    var moment = require('moment');
    require('moment/locale/th');

    useEffect(() => {
        document.title = 'บริการวัคซีน Covid-19';

        fetch("/api2/allsubdistrict"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setSubDistrictOption(result.data) }, (error) => { console.log(error) })

        fetch("/api/v1/title"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setTitleOption(result.data) }, (error) => { console.log(error) })

        fetch("/api2/school"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setSchoolOption(result.data) }, (error) => { console.log(error) })



            if (cid != null) {
                setCid(cid);
                handleSearch();
            }    
    },[]);


    useLayoutEffect(() => {

    }, []);

    //const titleOption =  [{ "titleKey": 101, "value": 101, "name": "ด.ช.", "label": "ด.ช." }, { "titleKey": 102, "value": 102, "name": "ด.ญ.", "label": "ด.ญ." }, { "titleKey": 103, "value": 103, "name": "นาย", "label": "นาย" }, { "titleKey": 104, "value": 104, "name": "นางสาว", "label": "นางสาว" }];



    const handleSearchMP = (evt) => {
        evt.preventDefault();

        var body = { "cid": Cid };

        fetch('/api2/vaccine/cert', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json' },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(
                (result) => {
                    //console.log(result);
                    setconfirmCid('');
                    setFullName(result.fullName);
                    setCertId(result.certID);
                    setVisit(result.visit);
                    setCertId(result.certID);
                    setIsSearch(true);
                },
                (error) => {
                    setIsSearch(true);

                }
            );
    }


    const handleSearchMP2 = () => {

        var body = { "cid": Cid };

        fetch('/api2/vaccine/cert', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json' },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(
                (result) => {
                    //console.log(result);
                    setconfirmCid(result.cid);
                    setFullName(result.fullName);
                    setCertId(result.certID);
                    setVisit(result.visit);
                    setCertId(result.certID);
                    setIsSearch(true);
                },
                (error) => {
                    setIsSearch(true);

                }
            );
    }

    const handleIsKnow = (num) => {

        var body = {
            "cid": confirmCid,
            "isKnow": num
        };

        fetch('/api2/student/know', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json' },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(
                (result) => {
                    setIsKnow(num);
                    if (num == 1)
                        alert("รับทราบแล้ว");
                    else alert("รับยังไม่รับทราบ");
                
                },
                (error) => {


                }
            );
    }


    const handleConfirmInj = (num) => {

        var body = {
            "cid": confirmCid,
            "totalVaccine": num
        };

        fetch('/api2/student/confirm', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json' },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(
                (result) => {
                    
                    if (num == 1) {
                        setinj1Hosp("1");
                    }
                    else {
                        setinj1Hosp("0");
                    }
                },
                (error) => {
    

                }
            );
    }



    const handleDistrict = (e) => {
        setDistrict(e);
        if (e != null && e.length == 6) {
            setAmphur(e.substring(0, 4));
            setProvince(e.substring(0, 2));
        }

    }

    const handleSearch = (evt) => {
        if (evt)
            evt.preventDefault();

        //var body = { "cid": Cid };

        var _cid = (cid != null) ? cid : Cid;

        fetch('/api2/school/cid2/' + _cid, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json-patch+json' },
            //body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(
                (result) => {
                    //console.log(result);
                    setconfirmCid('');
                    setFullName('');
                    setCertId('');
                    setVisit([]);
                    setCertId('');
                    setProvince('');
                    setDistrict(null);

                    setIsSearch(true);

                    setTargetType(result.status);

                    if ((result.status == 200) || (result.status == 400)) {
                        //setIsHideButton(true);
                        setconfirmCid(result.cid);
                        setFullName(result.firstName + ' ' + result.lastName);

                        setTitleName(result.titleName != null ? result.titleName:'');

                        setRowNumber(result.rowNumber);
                        setTitleKey(result.titleKey);
                        setSchoolKey(result.schoolKey);

                        setFirstName(result.firstName);
                        setLastName(result.lastName);
                        setBirthDT(result.birthDT);

                        var bd = moment(result.birthDT);

                        setbDay(bd.format('D'));
                        setbMonth(bd.format('M'));
                        setbYear(bd.format('YYYY'));


                        setQueueNumber(result.queueNumber1);
                        setQueueDate(result.queueDate1);
                        setQueueTime(result.queueTime1);

                        setQueueNumber2(result.queueNumber2);
                        setQueueDate2(result.queueDate2);
                        setQueueTime2(result.queueTime2);

                        setQueueNumber3(result.queueNumber3);
                        setQueueDate3(result.queueDate3);
                        setQueueTime3(result.queueTime3);

                        setQueueNumber4(result.queueNumber4);
                        setQueueDate4(result.queueDate4);
                        setQueueTime4(result.queueTime4);



                        setQueueNumber5(result.queueNumber5);
                        setQueueDate5(result.queueDate5);
                        setQueueTime5(result.queueTime5);

                        setQueueNumber6(result.queueNumber6);
                        setQueueDate6(result.queueDate6);
                        setQueueTime6(result.queueTime6);

                        setVaccineType(result.vaccineType);
                        setVaccinePlace(result.vaccinePlace);

                        setSchoolName(result.schoolName);
                        setClassYear(result.classYear);
                        setClassYearName(result.classYearName);
                        setClassRoom(result.classRoom);

                        setWeight(result.weight);
                        setHeight(result.height);
                        setTemp1(result.temp1 || '');
                        setTemp2(result.temp2 || '');

                        setinj1Hosp(result.inj1Hosp);
                        setinj2Hosp(result.inj2Hosp);
                        setAppointDT1(result.appointDT1);
                        setAppointDT2(result.appointDT2);


                        setSlotID(result.slotID);

              
                        setPhone(result.mobilePhone);
                        setAddress(result.addressNo);
                        setDistrict(result.thSubdistrictKey);
                        setAmphur(result.thDistrictKey);
                        setProvince(result.thProvinceKey);

                        setHospCode(result.hospitalCode);

                        setIsKnow(result.isKnow);
                        setIsNew(result.isNew);

                        if (result.vaccineType != null && result.vaccineType.length >= 3) {

                            fetch('/api2/vaccine/eventbooking/' + result.vaccineType, {
                                method: 'GET',
                                headers: { 'Content-Type': 'application/json-patch+json' },
                                //body: JSON.stringify(body)
                            })
                            .then(response2 => response2.json())
                            .then(
                                (re) => {
                                    setEventList(re)
                                });
                        }
                       

                    }
                    else if (result.status == 404) {
                        setErrorMsg2('ท่านไม่มีรายชื่ออยู่ในกลุ่มเป้าหมายครั้งนี้');

                        setFullName('');
                        setCid('');
                        setconfirmCid('');
                        setVisit([]);
                        setCertId('');
                        setProvince('');
                        setQueueNumber('');
                        setQueueDate('');
                        setQueueTime('');
                        setSchoolName('');
                        setSlotID('');
                        setPhone(null);
                        setAddress(null);
                        setDistrict(null);
                        setAmphur(null);
                        setProvince(null);
                    }
                    


                    
                },
                (error) => {
                    setIsSearch(true);

                }
            );
    }

    const handleSubmit = (evt) => {
        evt.preventDefault();

        var errMsg = '';
        var birthdate = moment([bYear, bMonth - 1, bDay]);
        
        if (!TitleKey && IsNew)
            errMsg = 'คำนำหน้า ';
        else if (!FirstName && IsNew)
            errMsg = 'ชื่อ';
        else if (!LastName && IsNew)
            errMsg = 'นามสกุล';
        else if (!Phone && IsNew)
            errMsg = 'หมายเลขโทรศัพท์';
        else if (!address && IsNew)
            errMsg = 'บ้านเลขที่';
        else if (!birthdate.isValid() && IsNew)
            errMsg = 'วันเดือนปีเกิดให้ถูกต้อง';
        else if (!district && IsNew)
            errMsg = 'ตำบล';
        else if (!HospCode)
            errMsg = 'ศุูนย์ฉีดและวัคซีน'
        //else if (!amphur)
        //    errMsg = 'อำเภอ';
        //else if (!province)
        //    errMsg = 'จังหวัด';
        //else if (!Weight)
        //    errMsg = 'น้ำหนัก';
        //else if (!Height)
        //    errMsg = 'ส่วนสูง';
        //else if (!SchoolKey && VaccineType != 'pz3' && VaccineType != 'az3' && VaccineType != 'sp1')
        //    errMsg = 'โรงเรียน';
      
        invalidPhone(!Phone);
        invalidAddress(!address);
        invalidDistrict(!district);
        //invalidAmphur(!amphur);
        //invalidProvince(!province);

        if (errMsg != '') {
            setErrMsg('กรุณาระบุ' + errMsg);
            setModalError(true);
        }
        else {
            setModalConfirm(true);
        }
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();

        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
        var birthdate = moment([bYear, bMonth - 1, bDay]);

        var cf = {
            cid: confirmCid,
            schoolKey: SchoolKey,
            titleKey: TitleKey,
            titleName: TitleName,
            firstName: FirstName,
            lastName: LastName,
            classYearName: ClassYearName,
            //birthDT: BirthDT,
            birthDT: birthdate.format('YYYY-MM-DD'),
            mobilePhone: Phone,
            addressNo: address,
            thSubdistrictKey: district,
            thDistrictKey: amphur,
            thProvinceKey: province,
            weight: Weight,
            height: Height,
            temp1: Temp1,
            temp2: Temp2,
            hospitalCode: HospCode,
            vaccineType: VaccineTypeNew,
            queueDT: QueueDT,
            vaccineEventKey: VaccineEventKey
        }

        console.log(JSON.stringify(cf));
  
        var action = (SlotID == null || SlotID == '') ? 'pfizer/confirm2/' : 'student/update2';
        
        fetch('/api2/'+action, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json'},
            body: JSON.stringify(cf)
        })
            .then(handleResponse)
            .then(
                (result) => {

                    if (result.status == 200) {
                        setModalConfirm(false);
                        //setIsHideButton(true);
                        window.scrollTo(0, 0);
                        setIcon("far fa-question-circle");

                        if (SlotID == null || SlotID == '') 
                            window.location.href = '/vaccinequeue/' + confirmCid;
                    }
                    else {
                        setModalConfirm(false);
                        setIcon("far fa-question-circle");
                        setErrMsg(result.msg + ' '+ result.desc);
                        setModalError(true);
                    }

                },
                (error) => {
                    setModalConfirm(false);
                    setIcon("far fa-question-circle");
                    setErrMsg(error);
                    setModalError(true);
                }
            );
        
    }

    const handleConfirmClear = (evt) => {
        evt.preventDefault();

        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        fetch('/api2/pfizer/clearbooking2/' + confirmCid, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json-patch+json'}
        })
            .then(handleResponse)
            .then(
                (result) => {

                    if (result.status == 200) {
                        setModalConfirm(false);
                        //setIsHideButton(true);
                        window.scrollTo(0, 0);
                        setIcon("far fa-question-circle");
                        window.location.href = '/vaccinebooking/';
                    }
                    else {
                        setModalConfirm(false);
                        setIcon("far fa-question-circle");
                        setErrMsg(result.msg + ' '+ result.desc);
                        setModalError(true);
                    }

                },
                (error) => {
                    setModalConfirm(false);
                    setIcon("far fa-question-circle");
                    setErrMsg(error);
                    setModalError(true);
                }
            );
        
    }


    const visitRender = Visit.map((v, index) => (
        
        <Row style={{ marginBottom: '10px' }}>
            {/*
            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> ชื่อวัคซีน : {v.visit_immunization[0].vaccine_name}</Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', height: '200px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                <Row style={{ textAlign: 'left', padding: '5px' }}>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">ชื่ออ้างอิง : {v.visit_immunization[0].vaccine_ref_name}</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">เข็มที่ : {index+1}</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">วันที่ได้รับ : {moment(v.visit_immunization[0].immunization_datetime).format('Do MMMM BBBB') }</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">Lot No : {v.visit_immunization[0].lot_number}</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">โรงพยาบาล : {v.hospital_name}</Col>
                </Row>
            </Col>
            */}
        </Row>

    ));


    const eventRender = EventList.map((e, index) => {

        var vt = "";
        var cnt = 0;

        if (e.vaccineEventName.indexOf("5-11") == -1 && e.vaccinePlace.indexOf("อาคารผู้ป่วยใน") >= 0) {
             
            if (e.vaccineName == 'Pfizer' /*&& moment(e.vaccineEventDT).diff(BirthDT, 'years', false) >= 12*/ ) {
                vt = 'pz' + e.vaccineNumber
                cnt += 1;
                return (
                    <Col className="ml-auto mr-auto" md="12">
                        <FormGroup check className="form-check-radio2">
                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                <Input
                                    defaultValue={"option" + index.toString()}
                                    id="inlineRadio1"
                                    name="AddressType"
                                    type="radio"
                                    onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                        </FormGroup>
                    </Col>
                )
            }

            else if (e.vaccineName == 'AstraZeneca' /*&& moment(e.vaccineEventDT).diff(BirthDT, 'years', false) >= 18*/) {
                vt = 'az' + e.vaccineNumber
                cnt += 1;
                return (
                    <Col className="ml-auto mr-auto" md="12">
                        <FormGroup check className="form-check-radio2">
                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                <Input
                                    defaultValue={"option" + index.toString()}
                                    id="inlineRadio1"
                                    name="AddressType"
                                    type="radio"
                                    onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                        </FormGroup>
                    </Col>
                )
            }

            else if (e.vaccineName == 'Moderna' /*&& moment(e.vaccineEventDT).diff(BirthDT, 'years', false) >= 18*/) {
                vt = 'md' + e.vaccineNumber
                cnt += 1;
                return (
                    <Col className="ml-auto mr-auto" md="12">
                        <FormGroup check className="form-check-radio2">
                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                <Input
                                    defaultValue={"option" + index.toString()}
                                    id="inlineRadio1"
                                    name="AddressType"
                                    type="radio"
                                    onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                        </FormGroup>
                    </Col>
                )
            }
                
            /*
             else if (visit.Count() == 1 && req.VaccineType.Substring(0, 2) == "pc" && age >= 5 && age <= 12)
             {

             }
             */
      
        }
        else return (<></>)
        /*
        else if (e.vaccineEventName.indexOf("5-11") >= 0) {
            if (e.vaccineName == 'Pfizer')
                vt = 'pc' + e.vaccineNumber

            return (
                <Col className="ml-auto mr-auto" md="12">2
                <FormGroup check className="form-check-radio2">
                    <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                        <Input
                            defaultValue={"option" + index.toString()}
                            id="inlineRadio1"
                            name="AddressType"
                            type="radio"
                            onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                        ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                </FormGroup>
            </Col>
            ) 
        }
*/



    });
    const eventRenderPSU = EventList.map((e, index) => {

        var vt = "";
        var cnt = 0;

        if (e.vaccineEventName.indexOf("5-11") == -1 && e.vaccinePlace.indexOf("หอประชุม") >= 0) {

            if (e.vaccineName == 'Pfizer' && moment(e.vaccineEventDT).diff(BirthDT, 'years', false) >= 12) {
                vt = 'pz' + e.vaccineNumber
                cnt += 1;
                return (
                    <Col className="ml-auto mr-auto" md="12">
                        <FormGroup check className="form-check-radio2">
                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                <Input
                                    defaultValue={"option" + index.toString()}
                                    id="inlineRadio1"
                                    name="AddressType"
                                    type="radio"
                                    onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                        </FormGroup>
                    </Col>
                )
            }

            else if (e.vaccineName == 'AstraZeneca' && moment(e.vaccineEventDT).diff(BirthDT, 'years', false) >= 18) {
                vt = 'az' + e.vaccineNumber
                cnt += 1;
                return (
                    <Col className="ml-auto mr-auto" md="12">
                        <FormGroup check className="form-check-radio2">
                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                <Input
                                    defaultValue={"option" + index.toString()}
                                    id="inlineRadio1"
                                    name="AddressType"
                                    type="radio"
                                    onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                        </FormGroup>
                    </Col>
                )
            }

            /*
             else if (visit.Count() == 1 && req.VaccineType.Substring(0, 2) == "pc" && age >= 5 && age <= 12)
             {

             }
             */

        }
        else return (<></>)
        /*
        else if (e.vaccineEventName.indexOf("5-11") >= 0) {
            if (e.vaccineName == 'Pfizer')
                vt = 'pc' + e.vaccineNumber

            return (
                <Col className="ml-auto mr-auto" md="12">2
                <FormGroup check className="form-check-radio2">
                    <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                        <Input
                            defaultValue={"option" + index.toString()}
                            id="inlineRadio1"
                            name="AddressType"
                            type="radio"
                            onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                        ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                </FormGroup>
            </Col>
            ) 
        }
*/



    });

    const eventRenderOther = EventList.map((e, index) => {

        var vt = "";
        var cnt = 0;

        if (e.vaccineEventName.indexOf("5-11") == -1 && e.vaccinePlace.indexOf("หอประชุม") == -1 && e.vaccinePlace.indexOf("ผู้ป่วยใน") == -1 ) {

            if (e.vaccineName == 'Pfizer' && moment(e.vaccineEventDT).diff(BirthDT, 'years', false) >= 12) {
                vt = 'pz' + e.vaccineNumber
                cnt += 1;
                return (
                    <Col className="ml-auto mr-auto" md="12">
                        <FormGroup check className="form-check-radio2">
                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                <Input
                                    defaultValue={"option" + index.toString()}
                                    id="inlineRadio1"
                                    name="AddressType"
                                    type="radio"
                                    onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} ) {e.vaccinePlace}
                </Label>
                        </FormGroup>
                    </Col>
                )
            }

            else if (e.vaccineName == 'AstraZeneca' && moment(e.vaccineEventDT).diff(BirthDT, 'years', false) >= 18) {
                vt = 'az' + e.vaccineNumber
                cnt += 1;
                return (
                    <Col className="ml-auto mr-auto" md="12">
                        <FormGroup check className="form-check-radio2">
                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                <Input
                                    defaultValue={"option" + index.toString()}
                                    id="inlineRadio1"
                                    name="AddressType"
                                    type="radio"
                                    onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                        </FormGroup>
                    </Col>
                )
            }

            /*
             else if (visit.Count() == 1 && req.VaccineType.Substring(0, 2) == "pc" && age >= 5 && age <= 12)
             {

             }
             */

        }
        else return (<></>)
        /*
        else if (e.vaccineEventName.indexOf("5-11") >= 0) {
            if (e.vaccineName == 'Pfizer')
                vt = 'pc' + e.vaccineNumber

            return (
                <Col className="ml-auto mr-auto" md="12">2
                <FormGroup check className="form-check-radio2">
                    <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                        <Input
                            defaultValue={"option" + index.toString()}
                            id="inlineRadio1"
                            name="AddressType"
                            type="radio"
                            onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                        ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                </FormGroup>
            </Col>
            ) 
        }
*/



    });



    const eventRender1 = EventList.map((e, index) => {

        var vt = "";

        if (e.vaccineName == 'Pfizer')
            vt = 'pz' + e.vaccineNumber
        else if (e.vaccineName == 'AstraZeneca')
            vt = 'az' + e.vaccineNumber

        return (e.vaccinePlace.indexOf("อาคารผู้ป่วยใน") >= 0) ? (
            <Col className="ml-auto mr-auto" md="12">
                <FormGroup check className="form-check-radio2">
                    <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                        <Input
                            defaultValue={"option"+index.toString()}
                            id="inlineRadio1"
                            name="AddressType"
                            type="radio"
                            onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); } }
                        ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                </FormGroup>
            </Col>    
        ) : (<></>)


    });



    const eventRender2 = EventList.map((e, index) => {

        var vt = "";
        var age = moment(e.vaccineEventDT).diff(BirthDT, 'years', false);

        if (e.vaccineName == 'Pfizer')
            vt = 'pc' + e.vaccineNumber

        return (
            (e.vaccinePlace.indexOf("หอประชุม") >= 0)
            && (e.vaccineEventName.indexOf("5-11") >= 0)
            && (
                (age >= 5 && age <= 11)
                ||
                (age >= 5 && age <= 12 && IsOrangePfizer)
            )
        ) ? (

                <Col className="ml-auto mr-auto" md="12">
                   <FormGroup check className="form-check-radio2">
                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                            <Input
                                defaultValue={"option" + index.toString()}
                                id="inlineRadio1"
                                name="AddressType"
                                type="radio"
                                onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                    </Label>
                    </FormGroup>
                </Col>
            ) : (<></>)

    });

    const eventRender3 = EventList.map((e, index) => {

        var vt = "";
        var age = moment(e.vaccineEventDT).diff(BirthDT, 'years', false);
        if (e.vaccineName == 'Pfizer')
            vt = 'pc' + e.vaccineNumber

        return (
                (e.vaccinePlace.indexOf("อาคารผู้ป่วยใน") >= 0)
                && (e.vaccineEventName.indexOf("5-11") >= 0)
                && (
                    (age >= 5 && age <= 11)
                    ||
                (age >= 5 && age <= 12 && IsOrangePfizer)
                )
            ) ? (
            <Col className="ml-auto mr-auto" md="12">
                <FormGroup check className="form-check-radio2">
                    <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                        <Input
                            defaultValue={"option" + index.toString()}
                            id="inlineRadio1"
                            name="AddressType"
                            type="radio"
                            onChange={a => { setHospCode('13755'); setVaccineTypeNew(vt); setQueueDT(e.vaccineEventDT); setVaccineEventKey(e.vaccineEventKey); }}
                        ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> {e.vaccineName} เข็ม {e.vaccineNumber} (   {moment(e.vaccineEventDT).format('Do MMMM BBBB')} )
                </Label>
                </FormGroup>
            </Col>
        ) : (<></>)
    });

    const notfoundRender = (
        <Row style={{ marginBottom: '10px' }}>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', color: 'red', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> {(Visit.length == 0) ? "ไม่พบข้อมูลของท่าน" : "หมายเหตุ"}</Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', height: '200px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                <Row style={{ textAlign: 'left', padding: '5px' }}>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">หากท่านได้รับวัคซีนจากรพ.โรคผิวหนังฯตรังแล้ว ยังไม่มีข้อมูลภายใน 24 ชั่วโมง</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12"></Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12"><a href="https://docs.google.com/forms/d/e/1FAIpQLSe79h_UWfLjiAIitasxg77RYKE1AcHTJuaVDQv0YcUc7dvcqw/viewform" target="_blank"> {"> สามารถลงทะเบียนแจ้งข้อมูลได้ที่นี่ <"} </a></Col>
                    
                </Row>
            </Col>

        </Row>
    );

    /*
    const liffId = { confirm: '1654063801-JpnXVx2a', tele: '1654063801-PwXBy90W', profile: '1654063801-mPYn4Dba', visit: '1654063801-JAvgrW63', visitBooking: '1654063801-5QXvb928' }
    const liff = window.liff;

    liff.init({
        liffId: (ServiceType == 'booking') ? liffId.visitBooking : liffId.visit
    })
        .then(() => {

            if (liff.isLoggedIn()) {
                liff.getProfile().then(function (profile) {
                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                if (user.isActive == 1) {

                                }
                                else {
                                    const { from } = props.location.state || { from: { pathname: "/profile/" + liffId.tele } };
                                    props.history.push(from);
                                }

                            },
                            error => {
                                const { from } = props.location.state || { from: { pathname: "/lineregister" } };
                                props.history.push(from);
                            }
                        );

                }).catch(function (error) {
                    //window.alert('Error getting profile: ' + error);
                });
            }
            else {

            }

        })
        .catch((err) => {

        });
    */
    //const currentUser = authenticationService.currentUserValue;
    //if (!currentUser) {
    //    return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    //}

    return (
        <>
            <Container>
                <Row>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '250px', color: 'white', backgroundColor: '#017dc3', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                        บริการวัคซีน Covid-19
                        {/*}
                        {FullName} <br />
                        {(CertId != "") ?
                            <a href={"https://co19cert.moph.go.th/moph-immu/#/vaccine/certificate?cid=" + CertId} target="_blank">
                                <img src={"https://co19cert.moph.go.th/moph-backend/api/immunization-stat/qr/" + CertId} width="145" /> <br />
                                <div style={{ fontSize: '0.9rem', color: 'white' }}> QRCode ใบรับรองแบบย่อ จากกระทรวงสาธารณสุข</div>
                            </a>
                            :
                            <></>
                        }
                        */}
                    </Col>

                </Row>
                <Row style={{ padding: '10px', margin: '-150px 0 0 0' }}>
                    <Col>
                        {
                            /*
                            (Visit.length == 0) ?
                             <>
                                
                             </>
                            :
                            <></>
                            */
                        }

                        <Row style={{ marginBottom: '10px' }}>
                            <Col>  <Input onChange={e => setCid(e.target.value)} style={{ fontSize: '1.2em', background: 'white' }} type="number" value={Cid} name="Cid" id="Cid" placeholder="กรุณาระบุเลขที่บัตรประจำตัวประชาชน" maxLength="13" /> </Col>
                        </Row>
                        <Row style={{ textAlign: 'center', marginBottom: '10px' }}>
                            <Col>
                                {(!IsHideButton) ?
                                    <Button color="primary" onClick={handleSearch} >ค้นหา</Button>
                                    :
                                    <></>
                                }
                            </Col>
                        </Row>

                        {/*(IsSearch && Visit.length < 2) ? notfoundRender : <></> */}



                        {
                            (TargetType == 400 || TargetType== 404 ) ?
                                <Row style={{ marginBottom: '10px' }}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', color: 'red', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> แจ้งเตือน</Col>
                                    
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', paddingBottom: '30px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>

                                        <Row style={{ textAlign: 'left', padding: '5px', fontSize: '1.2rem' }}>

                                            <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> {TitleName}{FirstName} {LastName} </Col>

                                            <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}>
                                                <div className="modal-profile">
                                                    <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                                </div>
                                            </Col>
                                   

                                            <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> {ErrorMsg2} </Col>

                                        </Row>
                                    </Col>
                                </Row>
                                :
                                <></>
                        }


                        {
                            (confirmCid != null && confirmCid != '' && SlotID != null && SlotID != '') ?
                                <Row style={{ marginBottom: '10px' }}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', color: 'blue', textAlign: 'center', borderRadius: '10px 10px 0 0' }}>{RowNumber}</Col>

                                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', paddingBottom: '30px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>

                                        <Row style={{ textAlign: 'left', padding: '5px', fontSize: '1.2rem' }}>

                                            <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> {FullName} </Col>
                                            {/*                                            
                                            <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> {SchoolName} {(ClassYear < 0 ? 'ป.' + (ClassYear * -1) : '')}{(ClassYear > 0 && ClassYear < 10 ? 'ม.' + ClassYear : '')}{(ClassYear != 0 && ClassYear < 10 ? '/' + ClassRoom : '')} </Col>
                                            <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> {SchoolName} {ClassYearName}/{ClassRoom}  </Col>
                                            */}

                                            {(QueueDate != null && QueueDate != '' && (VaccineType == 'pz1' || VaccineType == 'sp1' || VaccineType == 'az1') || VaccineType == 'pc1') ?
                                                <>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> {(VaccineType == 'pc1') ? "PC1: Pfizer เด็ก 5-11 ปี" : ""}{(VaccineType == 'pz1') ? "PZ1: Pfizer" : ""}{(VaccineType == 'sp1') ? "SP1: Sinopharm" : ""}{(VaccineType == 'az1') ? "AZ1: AstraZeneca" : ""}  เข็ม 1 </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> วันที่ {QueueDate}  </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}>
                                                        <div className="modal-profile">
                                                            {/*<i className="fas fa-syringe" style={{ color: 'blue', fontSize: '2em' }}></i>*/}
                                                            <QRCode size={120} value={confirmCid} />
                                                        </div>
                                                    </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '2rem', padding: '10px' }}> คิวที่ {QueueNumber} </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> เวลา {QueueTime} </Col>
                                                    {/*<Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ รร.วิเชียรมาตุ โดยรพ.โรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง</Col>*/}
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ {(RowNumber == '10683') ? "โรบินสันไลฟ์สไตล์ จ.ตรัง โดยโรงพยาบาลตรัง" : VaccinePlace }</Col>
                                                </> :
                                                <></>
                                            }

                                            {(QueueDate2 != null && QueueDate2 != '' && (VaccineType == 'pz2' || VaccineType == 'md2' || VaccineType == 'az2' || VaccineType == 'pc2')) ?
                                                <>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}>{(VaccineType == 'pc2') ? "PC2: Pfizer เด็ก 5-11 ปี" : ""}{(VaccineType == 'pz2') ? "PZ2: Pfizer" : ""}{(VaccineType == 'md2') ? "MD2: Moderna" : ""}{(VaccineType == 'az2') ? "AZ2: AstraZeneca" : ""} เข็ม 2 </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> วันที่ {QueueDate2}  </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}>
                                                        <div className="modal-profile">
                                                            {/*<i className="fas fa-syringe" style={{ color: 'blue', fontSize: '2em' }}></i>*/}
                                                            <QRCode size={120} value={confirmCid} />
                                                        </div>
                                                    </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '2rem', padding: '10px' }}> คิวที่ {QueueNumber2} </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> เวลา {QueueTime2} </Col>
                                                    {/*<Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ รร.วิเชียรมาตุ โดยรพ.โรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง</Col>*/}
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ {(RowNumber == '10683') ? "โรบินสันไลฟ์สไตล์ จ.ตรัง โดยโรงพยาบาลตรัง" : VaccinePlace}</Col>
                                                </> :
                                                <></>
                                            }



                                            {(QueueDate3 != null && QueueDate3 != '' && (VaccineType == 'pz3' || VaccineType == 'md3' || VaccineType == 'az3' || VaccineType == 'pc3')) ? 
                                                <>
                                                 {/*<Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}>{(VaccineType == 'pz3') ? "PZ3: Pfizer" : ""}{(VaccineType == 'md3') ? "MD3: Moderna" : ""}{(VaccineType == 'az3') ? "AZ3: AstraZeneca" : ""} เข็ม 3 </Col>*/}
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}>{(VaccineType == 'pc3') ? "PC3: Pfizer เด็ก 5-11 ปี" : ""}{(VaccineType == 'pz3') ? "PZ3: Pfizer" : ""}{(VaccineType == 'md3') ? "MD3: Moderna" : ""}{(VaccineType == 'az3') ? "AZ3: AstraZeneca" : ""} เข็ม 3 </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> วันที่ {QueueDate3}  </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}>
                                                        <div className="modal-profile">
                                                            {/*<i className="fas fa-syringe" style={{ color: 'blue', fontSize: '2em' }}></i>*/}
                                                            <QRCode size={120} value={confirmCid} />
                                                        </div>
                                                    </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '2rem', padding: '10px' }}> คิวที่ {QueueNumber3} </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> เวลา {QueueTime3} </Col>
                                                    {/*<Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ รร.วิเชียรมาตุ โดยรพ.โรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง</Col>*/}
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ {(RowNumber == '10683') ? "โรบินสันไลฟ์สไตล์ จ.ตรัง โดยโรงพยาบาลตรัง" : VaccinePlace}</Col>
                                                </> :
                                                <></>
                                            }

                                            {(QueueDate4 != null && QueueDate4 != '' && (VaccineType == 'pz4' || VaccineType == 'md4' || VaccineType == 'az4')) ?
                                                <>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}>{(VaccineType == 'pz4') ? "PZ4: Pfizer" : ""}{(VaccineType == 'md4') ? "MD4: Moderna" : ""}{(VaccineType == 'az4') ? "AZ4: AstraZeneca" : ""} เข็ม 4 </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> วันที่ {QueueDate4}  </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}>
                                                        <div className="modal-profile">
                                                            {/*<i className="fas fa-syringe" style={{ color: 'blue', fontSize: '2em' }}></i>*/}
                                                            <QRCode size={120} value={confirmCid} />
                                                        </div>
                                                    </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '2rem', padding: '10px' }}> คิวที่ {QueueNumber4} </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> เวลา {QueueTime4} </Col>
                                                    {/*<Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ รร.วิเชียรมาตุ โดยรพ.โรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง</Col>*/}
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ {(RowNumber == '10683') ? "โรบินสันไลฟ์สไตล์ จ.ตรัง โดยโรงพยาบาลตรัง" : VaccinePlace}</Col>
                                                </> :
                                                <></>
                                            }


                                            {(QueueDate5 != null && QueueDate5 != '' && (VaccineType == 'pz5' || VaccineType == 'md5' || VaccineType == 'az5')) ?
                                                <>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}>{(VaccineType == 'pz5') ? "PZ5: Pfizer" : ""}{(VaccineType == 'md5') ? "MD5: Moderna" : ""}{(VaccineType == 'az5') ? "AZ5: AstraZeneca" : ""} เข็ม 5 </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> วันที่ {QueueDate5}  </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}>
                                                        <div className="modal-profile">
                                                            {/*<i className="fas fa-syringe" style={{ color: 'blue', fontSize: '2em' }}></i>*/}
                                                            <QRCode size={120} value={confirmCid} />
                                                        </div>
                                                    </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '2rem', padding: '10px' }}> คิวที่ {QueueNumber5} </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> เวลา {QueueTime5} </Col>
                                                    {/*<Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ รร.วิเชียรมาตุ โดยรพ.โรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง</Col>*/}
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ {(RowNumber == '10683') ? "โรบินสันไลฟ์สไตล์ จ.ตรัง โดยโรงพยาบาลตรัง" : VaccinePlace}</Col>
                                                </> :
                                                <></>
                                            }

                                            {(QueueDate6 != null && QueueDate6 != '' && (VaccineType == 'pz6' || VaccineType == 'md6' || VaccineType == 'az6')) ?
                                                <>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}>{(VaccineType == 'pz6') ? "PZ6: Pfizer" : ""}{(VaccineType == 'md6') ? "MD6: Moderna" : ""}{(VaccineType == 'az6') ? "AZ6: AstraZeneca" : ""} เข็ม 6 </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> วันที่ {QueueDate6}  </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}>
                                                        <div className="modal-profile">
                                                            {/*<i className="fas fa-syringe" style={{ color: 'blue', fontSize: '2em' }}></i>*/}
                                                            <QRCode size={120} value={confirmCid} />
                                                        </div>
                                                    </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '2rem', padding: '10px' }}> คิวที่ {QueueNumber6} </Col>
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.5rem', padding: '10px' }}> เวลา {QueueTime6} </Col>
                                                    {/*<Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ รร.วิเชียรมาตุ โดยรพ.โรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง</Col>*/}
                                                    <Col md="12" style={{ textAlign: 'center', fontSize: '1.2rem', padding: '10px' }}> สถานที่ {(RowNumber == '10683') ? "โรบินสันไลฟ์สไตล์ จ.ตรัง โดยโรงพยาบาลตรัง" : VaccinePlace}</Col>
                                                </> :
                                                <></>
                                            }


                                        </Row>
                                    </Col>
                                </Row>
                                :
                                <></>
                        }



                        {visitRender}

                        {
                            (TargetType == 200 && (SlotID == null || SlotID == '')) ?
                            
                                <Row style={{ marginBottom: '10px' }}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', color: 'green', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> ข้อมูลส่วนตัว</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, paddingBottom: '30px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>

                                        <Row style={{ textAlign: 'left', padding: '5px', fontSize: '1.2rem' }}>



                                             {/*
                                                (moment().diff(BirthDT, 'years', false) < 18) ?
                                                    <Col md="12" style={{ fontSize: '0.8em' }}>
                                                        <TSSelect placeholder="โรงเรียน/สถานศึกษา" options={schoolOption} onChange={e => setSchoolKey(e)} value={SchoolKey} require marginBottom={'8px'}  />
                                                    </Col>
                                                    :
                                                    <></>
                                                       
                                            */}




                                            {
                                                (IsNew) ?
                                                    <>

                                                        <Col md="4" style={{ fontSize: '0.8em' }}>
                                                            <TSSelect placeholder="คำนำหน้า" options={titleOption} onChange={e => { setTitleKey(e); setTitleName((!e) ? '' : titleOption.find(t => t.value == e).label); }} value={TitleKey} require marginBottom={'8px'} /*invalid={i_title}*/ />
                                                        </Col>
                                                        <Col md="4" >
                                                            <TSText placeholder="ชื่อ" value={FirstName} background={'white'} onChange={e => setFirstName(e.target.value)} icon="fas fa-user-edit" />
                                                        </Col>
                                                        <Col md="4" >
                                                            <TSText placeholder="สกุล" value={LastName} background={'white'} onChange={e => setLastName(e.target.value)} icon="fas fa-user-edit" />
                                                        </Col>


                                                        <Col xs="12" md="3" style={{ fontSize: '0.8em' }}>
                                                            <TSSelect placeholder="วันเกิด/Birth Day" fixData="day" onChange={e => setbDay(e)} value={bDay} />
                                                        </Col>
                                                        <Col xs="12" md="3" style={{ fontSize: '0.8em' }}>
                                                            <TSSelect placeholder="เดือนเกิด/Birth Month" fixData="month" onChange={e => setbMonth(e)} value={bMonth} />
                                                        </Col>
                                                        <Col xs="12" md="3" style={{ fontSize: '0.8em' }}>

                                                            <TSSelect placeholder="ปีเกิด/Birth Year" fixData="year" onChange={e => setbYear(e)} value={bYear} />
                                                        </Col>

                                                        <Col md="3">
                                                            <TSText maxLength="10" type="tel" background={'white'} placeholder="หมายเลขโทรศัพท์" value={Phone || ''} onChange={e => setPhone(e.target.value)} require invalid={i_phone} />
                                                        </Col>


                                                        <Col md="6">
                                                            <TSText placeholder="ที่อยู่ปัจจุบัน บ้านเลขที่/หมู่/ซอย/ถนน " background={'white'} value={address || ''} onChange={e => setAddress(e.target.value)} require invalid={i_address} />
                                                        </Col>
                                                        <Col md="6" >
                                                            ตำบล (ค้นหาเฉพาะชื่อและเลือกตำบล)
                                                            <Autocomplete
                                                                onChange={e => handleDistrict(e)}
                                                                value={district}
                                                                suggestions={subDistrictOption}
                                                            />

                                                        </Col>

                                                    </>
                                                    :
                                                    <></>
                                                       
                                            }



                                            <Col md="4" >
                                                <TSText placeholder="น้ำหนัก" value={Weight || ''} background={'white'} onChange={e => setWeight(e.target.value)} require />
                                            </Col>
                                            <Col md="4" >
                                                <TSText placeholder="ส่วนสูง" value={Height || ''} background={'white'} onChange={e => setHeight(e.target.value)} require />
                                            </Col>

                                            <>{(moment().diff(BirthDT, 'years', false) >= 12)}</>

                                            {
                                                (SlotID == null || SlotID == '') ?
                                                    <>  
                                                   
                                                        <>
                                                            <Col md="12" style={{ margin: '10px', padding: '0' }}>

                                                                <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                                    สถานที่อื่นๆ <i className="far fa-hospital"></i>
                                                                </Col>
                                                                {eventRenderOther}
                                                            </Col>



                                                            <Col md="12" style={{margin: '10px', padding: '0' }}>
                                                            <Col style={{fontSize: 20, fontWeight: 'bold' }}>เลือกประเภทวัคซีน</Col>
                                                                <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                                    {/*หอประชุม มหาวิทยาลัยสงขลานครินทร์ วิทยาเขตตรัง โดยโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง*/} อาคารผู้ป่วยใน โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง <i className="far fa-hospital"></i>
                                                                </Col>
                                                                {eventRender}
                                                            </Col>

                                                            {/*
                                                            <Col md="12" style={{ margin: '10px', padding: '0' }}>

                                                                <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                                    หอประชุม มหาวิทยาลัยสงขลานครินทร์ วิทยาเขตตรัง โดยโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง<i className="far fa-hospital"></i>
                                                                </Col>
                                                                {eventRenderPSU}
                                                            </Col>
                                                            */}

                                                            {(moment().diff(BirthDT, 'years', false) <= 14 && 1 == 2) ?
                                                                <Col style={{ border: '1px solid orange', margin: '10px', padding: '0' }}>
                                                                    <Col className="ml-auto mr-auto" md="12">
                                                                        เฉพาะ Pfizer ฝาส้ม สำหรับ เด็ก อายุ 5-11 ปี
                                                                    {((moment().diff(BirthDT, 'years', false) >= 11 && moment().diff(BirthDT, 'years', false) <= 12)
                                                                            &&
                                                                            (VaccineType.substring(2, 3) == '2')
                                                                        ) ? <FormGroup check className="form-check-checkbox2">
                                                                                <Label check>
                                                                                    <Input

                                                                                        id="ckb1"
                                                                                        name="ckb1"
                                                                                        type="checkbox"
                                                                                        onChange={e => setIsOrangePfizer(e.target.checked)}
                                                                                    >
                                                                                    </Input>
                                                                                    <span className="form-check-sign2"></span>
                                                                                    <>ฉีดเข็ม 1 ฝาส้มมาแล้ว {IsOrangePfizer}</>
                                                                                </Label>
                                                                            </FormGroup> : <></>

                                                                        }


                                                                    </Col>
                                                                    {/*
                                                                    <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                                        หอประชุม มหาวิทยาลัยสงขลานครินทร์ วิทยาเขตตรัง โดยโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง (วัคซีน Pfizer สำหรับเด็ก 5-11 ปี) <i className="far fa-hospital"></i>
                                                                    </Col>
                                                                    {eventRender2}
                                                                */}
                                                                    <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                                        อาคารผู้ป่วยใน โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง (เก็บตกวัคซีน Pfizer สำหรับเด็ก 5-11 ปี) {/*อาคารผู้ป่วยใน โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง */}<i className="far fa-hospital"></i>
                                                                    </Col>
                                                                    {eventRender3}
                                                                </Col>
                                                                : <></>
                                                            }

                                                           
                                                            </>
                                                       

                                                        {((SchoolKey == '1') && (moment().diff(BirthDT, 'years', false) >= 12) && 1 == 2) ? 
                                                            <>
                                                                <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                                    หอประชุม มหาวิทยาลัยสงขลานครินทร์ วิทยาเขตตรัง โดยโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง (วัคซีน Pfizer เข็ม 3 นักเรียนวิเชียรมาตุ) <i className="far fa-hospital"></i>
                                                                </Col>

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue={"option11"}
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={a => { setHospCode('13755'); setVaccineTypeNew('pz3'); setQueueDT('2022-04-30'); setVaccineEventKey('326'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 นักเรียนวิเชียรมาตุ ( 30 เมษายน 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue={"option12"}
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={a => { setHospCode('13755'); setVaccineTypeNew('pz3'); setQueueDT('2022-05-01'); setVaccineEventKey('327'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 นักเรียนวิเชียรมาตุ ( 1 พฤษภาคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                            </> :
                                                            <>
                                                            </>
                                                        }

                                                        {/*
                                                        <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                           อาคารผู้ป่วยใน โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง <i className="far fa-hospital"></i>
                                                        </Col>
                                                        {eventRender}

                                                        <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                            หอประชุม มหาวิทยาลัยสงขลานครินทร์ วิทยาเขตตรัง โดยโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง <i className="far fa-hospital"></i>
                                                        </Col>
                                                        {eventRender2}
                                                        */}
                                                       


                                                        {(VaccineType == "pz4" && 1==2) ?
                                                            <>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option41"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('pz4'); setQueueDT('2022-01-26'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 4 ( 26 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option42"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('md4'); setQueueDT('2022-01-26'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Moderna เข็ม 4 ( 26 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option43"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('az4'); setQueueDT('2022-01-26'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> AstraZeneca เข็ม 4 ( 26 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>    




                                                            </>
                                                            : <></>
                                                        }

                                                        {(VaccineType == "pz3" && 1 == 2) ?
                                                            <>
                                                                {/*
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option31"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('pz3'); setQueueDT('2022-02-09'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 9 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>


                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option33"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('az3'); setQueueDT('2022-02-09'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> AstraZeneca เข็ม 3 ( 9 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                */}

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option32"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('pz3'); setQueueDT('2022-02-17'); setVaccineEventKey("998");  }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 17 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>
          

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option34"
                                                                                    id="inlineRadio1"
                                                                                    name="AddressType"
                                                                                    type="radio"
                                                                                    onChange={e => { setHospCode('13755'); setVaccineTypeNew('az3'); setQueueDT('2022-02-17'); setVaccineEventKey("999");  }}
                                                                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> AstraZeneca เข็ม 3 ( 17 กุมภาพันธ์ 2565 )xxx
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col> 
                                                               
                                                            </>
                                                            : <></>
                                                        }

                                                        {(VaccineType == "pz2" && 1 == 2) ?
                                                            <>
                                                                {/*
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option21"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('pz2'); setQueueDT('2022-02-09'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 2 ( 9 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option23"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('az2'); setQueueDT('2022-02-09'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> AstraZeneca เข็ม 2 ( 9 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                */}
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option22"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('pz2'); setQueueDT('2022-02-17'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 2 ( 17 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                


                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option24"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('az2'); setQueueDT('2022-02-17'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> AstraZeneca เข็ม 2 ( 17 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                            
                                                            </>
                                                            : <></>
                                                        }


                                                        {(VaccineType == "pz1" && 1 == 2) ?
                                                            <>
                                                                {/*
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option61"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('pz1'); setQueueDT('2022-02-09'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 1 ( 09 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option62"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                    onChange={e => { setHospCode('13755'); setVaccineTypeNew('az1'); setQueueDT('2022-02-09'); }}
                                                                                ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> AstraZeneca เข็ม 1 ( 09 กุมภาพันธ์ 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                
                                                                
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option63"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('pz1'); setQueueDT('2022-01-26'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 1 ( 26 มกราคม 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="option64"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('13755'); setVaccineTypeNew('az1'); setQueueDT('2022-01-26'); }}
                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> AstraZeneca เข็ม 1 ( 26 มกราคม 2565 )
                                                                </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                            */}
                                                            </>
                                                            : <></>
                                                        }

                                                        {/*}
                                                        <Col md="12" style={{ marginTop: '15px', fontSize: 18, fontWeight: 'bold' }}>
                                                            โรบินสัน ไลฟ์สไตล์ จ.ตรัง โดยโรงพยาบาลตรัง <i className="far fa-hospital"></i>
                                                        </Col>

                                                        {(VaccineType == "pz4") ?
                                                            <>
                                                              
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT41"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz4'); setQueueDT('2022-01-14'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 4 ( 14 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT42"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz4'); setQueueDT('2022-01-21'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 4 ( 21 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT43"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz4'); setQueueDT('2022-01-28'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 4 ( 28 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                


                                                            </>
                                                            : <></>
                                                        }

                                                        {(VaccineType == "pz3") ?
                                                            <>
                                                                {
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT31"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz3'); setQueueDT('2022-01-20'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 20 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT32"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz3'); setQueueDT('2022-01-21'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 21 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT33"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz3'); setQueueDT('2022-01-26'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 26 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT34"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz3'); setQueueDT('2022-01-27'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 27 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT35"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz3'); setQueueDT('2022-01-28'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 28 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                {
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT34"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz3'); setQueueDT('2022-01-21'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 21 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT43"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz3'); setQueueDT('2022-01-28'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 3 ( 28 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                


                                                            </>
                                                            : <></>
                                                        }
                                                        {(VaccineType == "pz2") ?
                                                            <>
                                                                {/*
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT21"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz2'); setQueueDT('2022-01-20'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 2 ( 20 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT22"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz2'); setQueueDT('2022-01-21'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 2 ( 21 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT23"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz2'); setQueueDT('2022-01-26'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 2 ( 26 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT24"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz2'); setQueueDT('2022-01-27'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 2 ( 27 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT25"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz2'); setQueueDT('2022-01-28'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 2 ( 28 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>

                                                            </>
                                                            : <></>
                                                        }
                                                        {(VaccineType == "pz1") ?
                                                            <>
                                                               
                                                                
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT11"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz1'); setQueueDT('2022-01-20'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 1 ( 20 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT12"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz1'); setQueueDT('2022-01-21'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 1 ( 21 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                

                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT13"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz1'); setQueueDT('2022-01-26'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 1 ( 26 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT14"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz1'); setQueueDT('2022-01-27'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 1 ( 27 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col className="ml-auto mr-auto" md="12">
                                                                    <FormGroup check className="form-check-radio2">
                                                                        <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                                            <Input
                                                                                defaultValue="optionT15"
                                                                                id="inlineRadio1"
                                                                                name="AddressType"
                                                                                type="radio"
                                                                                onChange={e => { setHospCode('10683'); setVaccineTypeNew('pz1'); setQueueDT('2022-01-28'); }}

                                                                            ></Input><span className="form-check-sign2" style={{ paddingRight: '20px' }}></span> Pfizer เข็ม 1 ( 28 มกราคม 2565 )
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>


                                                            </>
                                                            : <></>
                                                        }
                                                        
                                                        */}


                                                    </>
                                                    :
                                                    <></>
                                            }
                                       
                                        {/*
                                            <Col md="4" >
                                                <TSText placeholder="อุณหภูมิเข็ม 1" value={Temp1 || ''} background={'white'} onChange={e => setTemp1(e.target.value)} />
                                            </Col>
                                           
                                            <Col md="3" >
                                                <TSText placeholder="อุณหภูมิเข็ม 2" value={Temp2 || ''} background={'white'} onChange={e => setTemp2(e.target.value)} />
                                            </Col>    
                                         */}
                                        </Row>

                                        <Row>
                                            <Col className="text-center ml-auto mr-auto" md="86">
                                                <div className="send-button">
                                                     <Button
                                                                block
                                                                className="btn-round"
                                                                color="info"
                                                                href="#pablo"
                                                                onClick={handleSubmit}
                                                                size="lg"
                                                            >
                                                        {(SlotID == null || SlotID == '') ? 'ยืนยันสิทธิ' : 'แก้ไขข้อมูล'}
                                                    </Button> 

                                                    {/* Confirm */}
                                                    <Modal
                                                        modalClassName="modal-mini modal-info"
                                                        toggle={() => setModalConfirm(false)}
                                                        isOpen={modalConfirm}
                                                    >
                                                        <div className="modal-header justify-content-center">
                                                            <div className="modal-profile">
                                                                <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                                            </div>
                                                        </div>
                                                        <ModalBody>

                                                            <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล" : "กำลังตรวจสอบข้อมูล"}</p>
                                                            <p>  </p>
                                                        </ModalBody>
                                                        <div className="modal-footer">
                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={() => setModalConfirm(false)}
                                                            >
                                                                ยกเลิก
                                      </Button>

                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={handleConfirm}
                                                                disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                            //onClick={() => setModal2(false)}
                                                            >
                                                                ยืนยัน
                                      </Button>
                                                        </div>
                                                    </Modal>


                                                    {/* Error */}
                                                    <Modal
                                                        modalClassName="modal-mini modal-danger"
                                                        toggle={() => setModalError(false)}
                                                        isOpen={modalError}
                                                    >
                                                        <div className="modal-header justify-content-center">
                                                            <div className="modal-profile">
                                                                <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                                            </div>
                                                        </div>
                                                        <ModalBody>
                                                            <p>{(SlotID == null || SlotID == '') ? 'ไม่สามารถยืนยันสิทธิได้' : 'ไม่สามารถแก้ไขข้อมูลได้'}</p>
                                                            <p> {errMsg} </p>
                                                        </ModalBody>
                                                        <div className="modal-footer justify-content-center">
                                                            <Button
                                                                className="btn-neutral"
                                                                color="neutral"
                                                                type="button"
                                                                onClick={() => setModalError(false)}
                                                            >
                                                                ตกลง
                                      </Button>
                                                        </div>
                                                    </Modal>
                                                </div>
                                            </Col>
                                        </Row>

                                    </Col>
                            </Row>
                                :
                                <>
                                    
                                        <Row>
                                            <Col className="text-center ml-auto mr-auto" md="86">
                                                <div className="send-button">
                                                    <Button
                                                        block
                                                        className="btn-round"
                                                        color="danger"

                                                        onClick={() => setModalConfirm2(true)}
                                                        size="lg"
                                                    >
                                                        ยกเลิกสิทธิเดิม เพื่อจองใหม่วันอื่น
                                            </Button>

                                                    <Modal
                                                        modalClassName="modal-mini modal-info"
                                                        toggle={() => setModalConfirm2(false)}
                                                        isOpen={modalConfirm2}
                                                    >
                                                        <div className="modal-header justify-content-center">
                                                            <div className="modal-profile">
                                                                <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                                            </div>
                                                        </div>
                                                        <ModalBody>

                                                            <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการยกเลิกสิทธิ" : "กำลังตรวจสอบข้อมูล"}</p>
                                                            <p> หากยกเลิกสิทธิแล้วจะไม่สามารถลงทะเบียนฉีดในวันนั้นได้ ต้องยืนยันสิทธิใหม่เท่านั้น </p>
                                                        </ModalBody>
                                                        <div className="modal-footer">
                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={() => setModalConfirm2(false)}
                                                            >
                                                                ปิด
                                                    </Button>

                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={handleConfirmClear}
                                                                disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                            //onClick={() => setModal2(false)}
                                                            >
                                                                ยืนยันยกเลิก
                                                     </Button>
                                                        </div>
                                                    </Modal>
                                                </div>
                                            </Col>
                                        </Row>
                                    
                                </>
                        }

                        {/*
                        <Row style={{ marginBottom: '10px' }}>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> คำอธิบาย</Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', paddingBottom: '30px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}> 
                                
                                <Row style={{textAlign:'left', padding:'5px', fontSize:'1rem'}}>
                     
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">สำหรับนักเรียน 5-11 ที่หายจากโควิด</Col>
                                    
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">หายโควิดก่อน 6 เมษายน 2565 เลือกฉีดวันที่ 6,13 กรกฎาคม 2565</Col>
                                    
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">หายโควิดหลัง 6 เมษายน 2565 เลือกฉีดวันที่ 20 กรกฎาคม 2565</Col>

                                </Row>
                            </Col>
                        </Row>
                        
                        <Row style={{ marginBottom: '10px' }}>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> รายละเอียด</Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', paddingBottom: '30px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}> 
                                
                                <Row style={{textAlign:'left', padding:'5px'}}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">เข็มที่ 1 Sinovac วันที่ 24 กันยายน 2564</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">เข็มที่ 2 AstraZeneca วันที่ 22 ตุลาคม 2564</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">ศูนย์ฉีดวัคซีน</Col>
                                </Row>
                                <Row style={{textAlign:'left', padding:'5px', fontSize:'1rem'}}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">1. โรงเรียนจุฬาภรณราชวิทยาลัย ตรัง โดยโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง (4,000 Dose)</Col>
                                    
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">2. โรบินสันไลฟ์สไตล์ จ.ตรัง โดยโรงพยาบาลตรัง (800 Dose)</Col>
                                    
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">3. โรงพยาบาลทีอาร์พีเอช (TRPH-ตรังรวมแพทย์) (1,500 Dose)</Col>
                                    
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">4. มูลนิธิกุศลสถาน โดยโรงพยาบาลวัฒนแพทย์ (700 Dose)</Col>
                                </Row>
                            </Col>
                        </Row>
                        */}

                        {/*
                        <Row style={{ marginBottom: '10px' }}>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> ชื่อวัคซีน : Covid-19 Vaccine</Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', height: '200px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}> 
                                <Row style={{textAlign:'left', padding:'5px'}}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">ชื่ออ้างอิง : COVILO</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">เข็มที่ : 1</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">วันที่ได้รับ : 18 สิงหาคม 2564</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">Lot No : 1234567890</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">โรงพยาบาล : โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง</Col>
                                </Row>
                            </Col>

                        </Row>
                        <Row style={{ marginBottom: '10px' }}>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> ชื่อวัคซีน : Covid-19 Vaccine</Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', height: '200px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                                <Row style={{ textAlign: 'left', padding: '5px' }}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">ชื่ออ้างอิง : COVILO</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">เข็มที่ : 2</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">วันที่ได้รับ : 13 กันยายน 2564</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">Lot No : 1234567890</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">โรงพยาบาล : โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง</Col>
                                </Row>
                            </Col>
                        </Row>
                        */}

                    </Col>
                </Row>

           </Container>
        </>
    );
}

export default VaccinePfizerQueue2;
